import { TitleProps } from "@mantine/core";

import { Title } from "components";

interface SectionTitleProps extends TitleProps {
  label: string;
  isBankCredit?: boolean;
}

const SectionTitle = ({ label, isBankCredit = false, ...rest }: SectionTitleProps) => {
  const color = isBankCredit ? "#B046AC" : "var(--mantine-color-primary-6)";

  return (
    <Title order={5} mb={"sm"} c={color} {...rest}>
      {label}
    </Title>
  );
};

export default SectionTitle;
